import { CommonModule } from "@angular/common";
import { Component, Input, forwardRef } from "@angular/core";
import {
  NG_VALUE_ACCESSOR,
  ControlValueAccessor,
  FormsModule,
} from "@angular/forms";
import { DropdownModule } from "primeng/dropdown";

@Component({
  imports: [CommonModule, FormsModule, DropdownModule],
  selector: "nis-border-radius",
  templateUrl: "./border-radius.component.html",
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BorderRadiusComponent),
      multi: true,
    },
  ],
})
export class BorderRadiusComponent implements ControlValueAccessor {
  borderRadiusOptions = [
    {
      code: null,
      name: "",
    },
    {
      code: "0",
    },
    {
      code: "0.125rem",
    },
    {
      code: "0.25rem",
    },
    {
      code: "0.375rem",
    },
    {
      code: "0.5rem",
    },
    {
      code: "0.75rem",
    },
    {
      code: "1rem",
    },
    {
      code: "1.5rem",
    },
    {
      code: "9999px",
    },
  ];
  borderTopLeftRadius: string = undefined;
  borderTopRightRadius: string = undefined;
  borderBottomLeftRadius: string = undefined;
  borderBottomRightRadius: string = undefined;

  private onChange: (value: any) => void;
  private onTouched: () => void;

  writeValue(value: any): void {
    if (value) {
      const values = value.split(" ");
      if (values.length === 4) {
        this.borderTopLeftRadius = values[0];
        this.borderTopRightRadius = values[1];
        this.borderBottomLeftRadius = values[2];
        this.borderBottomRightRadius = values[3];
      }
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Handle the component's disabled state if necessary
  }

  updateBorder() {
    if (
      this.borderTopLeftRadius === undefined ||
      this.borderTopRightRadius === undefined ||
      this.borderBottomLeftRadius === undefined ||
      this.borderBottomRightRadius === undefined
    ) {
      return;
    }
    this.onChange(
      `${this.borderTopLeftRadius} ${this.borderTopRightRadius} ${this.borderBottomLeftRadius} ${this.borderBottomRightRadius}`
    );
    this.onTouched();
  }
}
